import {useVersionsContext} from "../../../../Context/versions-context";
import React, {useEffect, useState} from "react";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import {formatDateTime} from "../../../Utils/ConvertDate";
import PageTitle from "../../../Utils/smsTitle";
import {SubHeader} from "../../../../Containers/SubHeader";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import {
    ExpiredStatus,
    FinishedStatus, OtherMedicine, P,
    PendingStatus,
    Processing,
    StyledIcon,
    StyledLibraryIcon, StyledRemoveIcon
} from "../../../DoctorsModule/doctorStyles";
import {CenteredContainer} from "../../../Utils/styledComponents";
import {LoadingGif} from "../../../Utils/Loader";
import {CollapsibleList, DataCell, ItemText, ModuleTable} from "../../../Utils/Lists/CollapsibleList";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import TableRow from "@material-ui/core/TableRow";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import {connect} from "react-redux";

import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages} from "../../../../Helpers/ErrorMessages";
import CustomDialog from "../../../Utils/Dialogs/CustomDialog";
import {NewPrescriptionRequest} from "./PrescriptionRequest";
import {ViewPrescriptionReport} from "./ViewPrescriptionReport";
import TextField from "../../../Utils/FormInputs/TextField";
import DeleteDialog from "../../../Utils/Dialogs/DeleteDialog";

export const filteredPrescriptionArr = (arr) =>{

    return arr.filter(item=>Boolean(item)).filter(item=>item.product_id && !item.isExpired).map(presc => ({
        dosage: presc.dosage,
        number_of_days: +presc.number_of_days,
        key_information: presc.key_information,
        rate: presc.rate,
        product_id: presc.product_id,
        frequency: presc.frequency,
        quantity_prescribed:+presc.quantity_prescribed || +presc.quantity,
        is_provided: presc.is_provided,
        is_provider: presc.is_provider,
        currency_id:presc.currency_id,
        quantity_billable:presc.quantity_billable,
        prescription_detial_id: presc.prescription_detial_id,
        prescription_id: +presc.prescription_id,
        quantity_to_bill:+presc.quantity_to_bill,
        bill_details:{
            product_id: presc.product_id,
            rate: +presc.rate,
            quantity:+presc.quantity,
            invoice_no: presc.invoice_no,
            bill_id: +presc.bill_id,
            prescription_id: +presc.prescription_id,
            prescription_detial_id: presc.prescription_detial_id
        },
        bill_type:3,

    }))
}


const sundriesHeadData = [{ item: "Sundry Name" }, { item: "status" },{item:"Action"}];

const  GynAndObsPreviousPrescription= ({ actions, snackbars, match: { params } }) => {

    const user = JSON.parse(sessionStorage.getItem("user"));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? 1 : _token.user_roles_id;

    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;

    const {subscription} = useVersionsContext()
    const version = subscription?.version
    const isPremium = version === 'Premium'

    const {patient_number, visit_id, patient_type} = params;

    const [allPrescriptions, setAllPrescriptions] = useState([])
    const [status, setStatus] = useState('idle')

    const [openDialog, setOpenDialog] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [isBlocking, setIsBlocking] = useState(false)
    const [isBlockDialog, setIsBlockDialog] = useState(false)
    const [prescription_id, setPrescriptionId] = useState('')
    const [openReport, setOpenReport] = useState(false)
    const [isEditing, setIsEditing] = useState('idle')
    const [openDelete, setOpenDelete] = useState(false)
    const [deleteData, setDeleteData] = useState({})
    const [openEditDialog, setOpenEditDialog] = useState(false)

    const isResolved = isSubmitted === 'resolved'

    const isEditResolved = isEditing === 'resolved'



    const groupByPrescriptionId = (arr=[]) =>{
        let result = []
        let knowledge = {}
        arr.forEach(item =>{
            let id = item.prescription_id;
            if(id in knowledge){
                result[knowledge[id]].drugs.push(item)
            }else {
                knowledge[id] = result.length
                result.push({
                    id: id,
                    date: formatDateTime(item.date_created_),
                    doctor_name:`${item.prescribed_by_first_name ? item.prescribed_by_first_name:''} ${item.prescribed_by_last_name ? item.prescribed_by_last_name : ''}`,
                    dispensed_by: `${!item.dispensed_by_frist_name ? "" : item.dispensed_by_frist_name} ${!item.dispensed_by_last_name ? "" : item.dispensed_by_last_name}`,
                    dispensed_at: item.dispensed_at ? formatDateTime(item.dispensed_at) : '',
                    drugs: [item]
                })

            }
        })
        return result
    }

    useEffect(() => {
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        setStatus('pending')
        const url = patient_type === '1' ? 'get_previous_prescription_by_visit_id' : 'get_previous_inprescription_by_visit_id'
        axios.post(`${config.smsUrl}/cdoctor/${url}`, formData).then(res => {
            const resp = res.data;
            const data = !resp ? {} : resp;
            const prescrip = data.prescription ? data.prescription : [];
            const other_meds = data.other_med ? data.other_med : [];
            const others = other_meds.map(item=>({...item, product_name:item.other_medicine}))
            const drugs = [...prescrip, ...others]
            const presc = groupByPrescriptionId(drugs)
            const arr = presc.map(item=>({...item, open:true}))
            setAllPrescriptions(arr)
            setStatus('success')
        }).catch(error => {
            errorMessages(error, null, actions)
            setStatus('error')
        });
    }, [isResolved, isEditResolved])


    const handleOpen = (id) =>{
        const itemsArr = allPrescriptions.map((item)=>{
            if(item.id === id){
                return {...item,open:!item.open}
            }else{
                return item
            }
        })
        setAllPrescriptions(itemsArr)
    }

    const getItemCost = (product_id,parentIdx,childIdx) =>{
        axios.post(`${config.smsUrl}/cbilling/item_cost`, {visit_id: +visit_id, item_id:+product_id, item_type:'product'}).then(res => {
            const resObj = res.data;
            const dataObj = !resObj.data ? {} : resObj.data;
            const arr = allPrescriptions.map((item, pIndex)=>{
                if (parentIdx === pIndex){
                    return {
                        ...item,
                        drugs: item.drugs.map((product, cIndex)=>{
                            if (childIdx === cIndex){
                                return {
                                    ...product,
                                    isEdit:true,
                                    rate:  dataObj.cost ?? 0, is_provider:dataObj.is_provider,
                                    currency: dataObj.currency_id, currency_symbol: dataObj.currency,
                                    is_provided:dataObj.is_provided
                                }
                            }
                            return product
                        })
                    }
                }
                return item

            })
            setAllPrescriptions(arr)

        }).catch(error => {
            errorMessages(error, null, actions)
        });
    }

    const handleOpenEdit = (parentIdx,childIdx, editType) =>{
        const arr = allPrescriptions.map((item, pIndex)=>{
            if (parentIdx === pIndex){
                return {
                    ...item,
                    drugs: item.drugs.map((product, cIndex)=>{
                        if (childIdx === cIndex){
                            return {
                                ...product,
                                isEdit:editType
                            }
                        }
                        return product
                    })
                }
            }
            return item

        })
        setAllPrescriptions(arr)
    }

    const handleChangeValue = (event, parentIdx,childIdx) =>{
        const {name, value} = event.target
        const arr = allPrescriptions.map((item, pIndex)=>{
            if (parentIdx === pIndex){
                return {
                    ...item,
                    drugs: item.drugs.map((product, cIndex)=>{
                        if (childIdx === cIndex){
                            return {
                                ...product,
                                [name]:value
                            }
                        }
                        return product
                    })
                }
            }
            return item

        })
        setAllPrescriptions(arr)
    }

    const handleEditPrescription = (item, pIdx=0, cIndx=0) => {
        const params = {
            visit_id: +visit_id,
            user_roles_id,
            ...item
        }
        setIsEditing('pending');
        axios.post(`${config.smsUrl}/cdoctor/update_prescription`, {...params}).then(() => {
            actions.snackbarActions.snackSuccess(`Drug details updated successfully`);
            setIsEditing('resolved');
            handleOpenEdit(pIdx, cIndx, false)
            setOpenDelete(false)
        }).catch(err => {
            errorMessages(err, null, actions)
            setIsEditing('rejected');
        })

    };



    const handleCloseDialog = () =>{
        if(isBlocking){
            setIsBlockDialog(true)
        }else{
            setIsBlockDialog(false)
            setIsBlocking(false)
            setOpenDialog(false);
        }
    }

    const handleCloseEditDialog = () =>{
        if(isBlocking){
            setIsBlockDialog(true)
        }else{
            setIsBlockDialog(false)
            setIsBlocking(false)
            setOpenEditDialog(false);
        }
    }

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar();
    };

    const isLoading = status === 'pending'
    const isSuccess = status === 'success'
    const isError = status === 'error'



    const { openBar, type, message } = snackbars;

    const isPendingEdit = isEditing === 'pending'



    const headData = [
        { item: "Drug Name", toolTip: "Enter drug name", isRequired: true },
        isPremium ? {item:'Quantity to bill',  toolTip:'Enter quantity to bill', isRequired: true, tier:"Premium"}: null,
        { item: "Quantity Prescribed", toolTip: "Enter quantity to prescribed" },
        { item: "Dosage", toolTip: "Enter dosage" },
        { item: "Frequency", toolTip: "Enter frequency" },
        { item: "No. of Days", toolTip: "Enter number of days" },
        { item: "Instructions", toolTip: "Enter instructions" },
        { item: "Status", toolTip: "status" },
        { item: "Action", toolTip: "action" },
    ];

    const deleteButtons = (
        <>
            <button type='button' onClick={()=>handleEditPrescription(deleteData)} disabled={isPendingEdit}
                    className='btn btn-sm small-btn sms-btn-dismiss mr-3'>{isPendingEdit ? 'Deleting...':'Delete'}</button>
            <button type='button' onClick={()=>setOpenDelete(false)} className='btn btn-sm small-btn sms-gray-btn mr-3'>Cancel</button>
        </>
    )

    return (
        <div className="journals">
            <PageTitle title="Prescription"/>
            <SubHeader
                title="Doctor"
                subTitle="Prescription"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <MainSnackbar
                open={openBar}
                handleCloseBar={closeSnackbar}
                variant={type}
                message={message}
            />

            <DeleteDialog handleClose={()=>setOpenDelete(false)} title={`Delete ${deleteData?.product_name}`}
                          openDialog={openDelete} message='delete' text={deleteData?.product_name}>
                {deleteButtons}
            </DeleteDialog>

            <CustomDialog title='Add Prescription' open={openDialog} handleClose={handleCloseDialog} maxWidth='lg'>
                <NewPrescriptionRequest {...{actions, visit_id,isSubmitted, setIsSubmitted, setOpenDialog,
                    isBlocking, setIsBlocking,isBlockDialog, setIsBlockDialog}}/>
            </CustomDialog>

            <CustomDialog title='Edit Prescription' open={openEditDialog} handleClose={handleCloseEditDialog} maxWidth='lg'>
                <NewPrescriptionRequest {...{actions, visit_id,isSubmitted, setIsSubmitted, setOpenDialog:setOpenEditDialog,
                    isBlocking, setIsBlocking,isBlockDialog, setIsBlockDialog, prescription_id}}/>
            </CustomDialog>


            <CustomDialog title='View Report' open={openReport} handleClose={()=>setOpenReport(false)} maxWidth='md'>
                <ViewPrescriptionReport {...{actions, visit_id,prescription_id}}/>
            </CustomDialog>

            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                <div style={{padding: '12px 16px'}}>
                    <button
                        onClick={()=>setOpenDialog(true)}
                        type="button"
                        className="btn btn-sm sms-info-btn mb-2"
                    >
                        Add Prescription
                    </button>
                    {isLoading ? (
                        <CenteredContainer>
                            <LoadingGif />
                        </CenteredContainer>
                    ) : null}
                    {isSuccess ? (
                        allPrescriptions.length > 0 ? (
                            allPrescriptions.map((item, idx) => {
                                const isAddedOut = item.drugs.filter((item) => item.visit_id).some((item) => item.status === 0 || item.pay_status === 3);
                                const sundry = item.drugs.filter((item) => item.category_name === "Sundries");
                                const presc = item.drugs.filter((item) => item.category_name === "Medicine" || !item.category_name);

                                const user = (
                                    <>
                                        <ItemText primary={<span>Prescribed By: <strong>{item.doctor_name}</strong></span>}/>
                                        {item.dispensed_by ? (<ItemText primary={<span>Dispensed By: <strong>{item.dispensed_by}</strong></span>}/>) : null}
                                        {item.dispensed_at ? (<ItemText primary={<span>Dispensed At: <strong>{item.dispensed_at}</strong></span>}/>) : null}
                                    </>
                                );

                                return (
                                    <CollapsibleList
                                        key={item.id}
                                        open={item.open}
                                        name={item.date}
                                        handleOpen={() => handleOpen(item.id)}
                                        button={
                                            <>
                                                {/*{isAdded ? (*/}
                                                {/*    <Tooltip title="Edit Prescription">*/}
                                                {/*        <IconButton onClick={() => handleOpenEdit(item)}>*/}
                                                {/*            <StyledIcon />*/}
                                                {/*        </IconButton>*/}
                                                {/*    </Tooltip>*/}
                                                {/*) : null}*/}
                                                <Tooltip title="Prescription Report">
                                                    <IconButton onClick={() => {
                                                        setOpenReport(true)
                                                        setPrescriptionId(item.id)
                                                    }}>
                                                        <StyledLibraryIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        }
                                        user={user}
                                    >
                                        {presc.length > 0 ? (
                                            <ModuleTable headData={headData.filter(item=>Boolean(item))}>
                                                {presc.map((row, index) => {
                                                    const isOther = row.status === null || row.status === undefined;
                                                    const isEdit  = row.status === 0 || isOther || row.pay_status === 3;


                                                    const outPatientStatus = {
                                                        0: <PendingStatus>Pending</PendingStatus>,
                                                        1: <Processing>Paid</Processing>,
                                                        2: (
                                                            <FinishedStatus>
                                                                Dispensed(out-patient)
                                                            </FinishedStatus>
                                                        ),
                                                        3: <PendingStatus>Pending</PendingStatus>,
                                                        4: <FinishedStatus>Dispensed</FinishedStatus>,
                                                        7: <ExpiredStatus>Stopped</ExpiredStatus>,
                                                    };

                                                    const prescriptionData = {
                                                        bill_type: 3,
                                                        prescription_id:item.id,
                                                        products: [],
                                                        invoices_edited : !isOther ?  filteredPrescriptionArr([row]) : [],
                                                        invoices_removed: [],
                                                        sundries: [],
                                                        other_products: isOther ? [row].map(({other_medicine, dosage, quantity_prescribed:quantity,
                                                                                                  number_of_days, key_information, frequency, ...item})=>({
                                                            other_medicine, dosage, quantity:+quantity, number_of_days, key_information, frequency
                                                        })):[]
                                                    }


                                                    const saveButtons = (
                                                        <>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-sm sms-btn small-btn mr-3"
                                                                onClick={() => handleEditPrescription(prescriptionData, idx, index)}
                                                                style={{ marginTop: "5px", marginBottom: "5px" }}
                                                            >
                                                                {isPendingEdit ? "Saving..." : "Save"}
                                                            </button>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-sm sms-gray-btn small-btn"
                                                                onClick={() => handleOpenEdit(idx,index, false)}
                                                                style={{ marginTop: "5px", marginBottom: "5px" }}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </>
                                                    );

                                                    const updateButtons = row.isEdit ? saveButtons :  (
                                                        <React.Fragment>
                                                            <Tooltip title='Edit drug'>
                                                                <IconButton
                                                                    onClick={() => {
                                                                        if (isOther) {
                                                                            handleOpenEdit(idx, index, true)
                                                                        }else {
                                                                            getItemCost(row.product_id,idx, index)
                                                                        }
                                                                    }}
                                                                >
                                                                    <StyledIcon/>
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title='Delete drug'>
                                                                <IconButton
                                                                    onClick={() => {
                                                                    setOpenDelete(true)
                                                                    setDeleteData({
                                                                        bill_type: 3,
                                                                        prescription_id:item.id,
                                                                        products: [],
                                                                        invoices_edited :  [],
                                                                        invoices_removed: filteredPrescriptionArr([row]),
                                                                        sundries: [],
                                                                        other_products: [],
                                                                        product_name:row.product_name
                                                                        })
                                                                    }}
                                                                >
                                                                    <StyledRemoveIcon/>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </React.Fragment>
                                                    )

                                                    return (
                                                        <TableRow key={index}>
                                                            <DataCell>
                                                                <span>
                                                                  {row.isEdit && isOther ?
                                                                      <TextField  id='other_medicine'
                                                                                  value={row.other_medicine} name='other_medicine'
                                                                                  data-test="other_medicine"
                                                                                  onChange={e => handleChangeValue(e,idx ,index)}/>:
                                                                      <>
                                                                          {row.product_name} {isOther ? (
                                                                              <OtherMedicine>Other</OtherMedicine>
                                                                          ) : null}
                                                                      </>

                                                                  }

                                                                </span>
                                                            </DataCell>
                                                            {isPremium ? (
                                                                <DataCell>
                                                                    {row.isEdit && !isOther ?
                                                                        <TextField  id='quantity_to_bill'
                                                                                    value={row.quantity_to_bill} name='quantity_to_bill'
                                                                                    data-test="quantity_to_bill"
                                                                                    onChange={e => handleChangeValue(e,idx ,index)}/>:
                                                                        row.quantity_to_bill
                                                                    }
                                                                </DataCell>
                                                            ) : null}
                                                            <DataCell>{
                                                                row.isEdit ?
                                                                    <TextField  id='quantity_prescribed'
                                                                                value={row.quantity_prescribed} name='quantity_prescribed'
                                                                                data-test="quantity_prescribed"
                                                                                onChange={e => handleChangeValue(e,idx ,index)}/>:
                                                                row.quantity_prescribed
                                                            }</DataCell>
                                                            <DataCell>{
                                                                row.isEdit ?
                                                                    <TextField  id='dosage'
                                                                                value={row.dosage} name='dosage'
                                                                                data-test="dosage"
                                                                                onChange={e => handleChangeValue(e,idx ,index)}/>:
                                                                row.dosage
                                                            }</DataCell>
                                                            <DataCell>{
                                                                row.isEdit ?
                                                                    <TextField  id='frequency'
                                                                                value={row.frequency} name='frequency'
                                                                                data-test="frequency"
                                                                                onChange={e => handleChangeValue(e,idx ,index)}/>:
                                                                row.frequency
                                                            }</DataCell>
                                                            <DataCell>{
                                                                row.isEdit ?
                                                                    <TextField  id='number_of_days'
                                                                                value={row.number_of_days} name='number_of_days'
                                                                                data-test="number_of_days"
                                                                                onChange={e => handleChangeValue(e,idx ,index)}/>:
                                                                row.number_of_days
                                                            }</DataCell>
                                                            <DataCell>{
                                                                row.isEdit ?
                                                                    <TextField  id='key_information'
                                                                                value={row.key_information} name='key_information'
                                                                                data-test="key_information"
                                                                                onChange={e => handleChangeValue(e,idx ,index)}/>:
                                                                row.key_information
                                                            }</DataCell>
                                                            <DataCell>{outPatientStatus[row.status]}</DataCell>
                                                            <DataCell>
                                                                {isEdit ? updateButtons : null}
                                                            </DataCell>
                                                        </TableRow>
                                                    );
                                                })}
                                                {isAddedOut ?  <TableRow>
                                                    <DataCell colSpan={headData.length}>
                                                        <button type="button" onClick={()=>{
                                                            setPrescriptionId(item.id)
                                                            setOpenEditDialog(true)
                                                        }} className="btn btn-sm sms-gray-btn"
                                                                id="add-row">Add another drug
                                                        </button>
                                                    </DataCell>
                                                </TableRow>: null}
                                            </ModuleTable>
                                        ) : null}
                                        {sundry.length > 0 ? (
                                            <ModuleTable headData={sundriesHeadData}>
                                                {sundry.map((row, index) => {
                                                    const isInPatientPending = row.status === 3;
                                                    const isOutPatientPending = row.status === 0;
                                                    const isOutPatientFinished = row.status === 1;
                                                    const isInPatientFinished = row.status === 4;
                                                    const isStopped = row.status === 7;
                                                    const isPending =
                                                        patient_type === "1"
                                                            ? isOutPatientPending
                                                            : isInPatientPending;
                                                    const isFinished =
                                                        patient_type === "1"
                                                            ? isOutPatientFinished
                                                            : isInPatientFinished;
                                                    const isOther =
                                                        row.status === null || row.status === undefined;
                                                    return (
                                                        <TableRow key={index}>
                                                            <DataCell>
                                                                <span>
                                                                  {row.product_name}
                                                                    {isOther ? (
                                                                        <OtherMedicine>Other</OtherMedicine>
                                                                    ) : null}
                                                                </span>
                                                            </DataCell>
                                                            <DataCell>
                                                                {isPending ? (
                                                                    <PendingStatus>Pending</PendingStatus>
                                                                ) : isFinished ? (
                                                                    <FinishedStatus>Dispensed</FinishedStatus>
                                                                ) : isStopped ? (
                                                                    <PendingStatus>Stopped</PendingStatus>
                                                                ) : null}
                                                            </DataCell>
                                                            <DataCell>
                                                                {isOutPatientPending ? <Tooltip title='Delete sundry'>
                                                                    <IconButton
                                                                        onClick={() => {
                                                                            setOpenDelete(true)
                                                                            setDeleteData({
                                                                                bill_type: 3,
                                                                                prescription_id:item.id,
                                                                                products: [],
                                                                                invoices_edited :  [],
                                                                                invoices_removed: filteredPrescriptionArr([row]),
                                                                                sundries: [],
                                                                                other_products: [],
                                                                                product_name:row.product_name
                                                                            })
                                                                        }}
                                                                    >
                                                                        <StyledRemoveIcon/>
                                                                    </IconButton>
                                                                </Tooltip>:null}
                                                            </DataCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </ModuleTable>
                                        ) : null}
                                    </CollapsibleList>
                                );
                            })
                        ) : (
                            <CenteredContainer>
                                <P>
                                    No drugs prescribed for patient, click the add prescription
                                    button to prescribe drugs for patient
                                </P>
                            </CenteredContainer>
                        )
                    ) : null}
                    {isError ? (
                        <CenteredContainer>
                            <P>An error occurred on the server</P>
                        </CenteredContainer>
                    ) : null}
                </div>
            </ObGynSidebar>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        snackbars: state.snackbar,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch),
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GynAndObsPreviousPrescription);